
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kz89i", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=ja.1ca79984.js.map
